const LOGO_SRC = "/logo_icon.png";

export function Logo({ className = "", size = "md", dark = false }) {
  const img = {
    sm: "h-11",
    md: "h-14",
    lg: "h-20",
    xl: "h-28 sm:h-32",
  }[size] || "h-14";

  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_SRC}
        alt="Nikah Match"
        className={`${img} w-auto shrink-0 object-contain ${dark ? "drop-shadow-xl" : "drop-shadow-sm"}`}
      />
    </div>
  );
}
